import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {BaseComponent} from 'compob2b-libs';
import {Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';
import {DamFilterService} from '../../../../../dam-filter.service';

@Component({
  selector: 'app-selected-filters',
  templateUrl: './selected-filters.component.html',
  styleUrls: ['./selected-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedFiltersComponent extends BaseComponent implements OnInit {

  getFeatures = false;
  formFilter = new UntypedFormGroup({});
  @Input() fieldsFeatures: FormlyFieldConfig[];
  @Input() fieldsFeaturesFast: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
  modelFeatures: any = {};
  // customerGroup: CustomerGroup;
  cntActiveFeatures = 0;
  subscription: Subscription;
  keyword = '';
  catalogId = 0;
  catalogHeader = '';
  paramsSubscribe$: Subscription;

  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly filter: DamFilterService
  ) {
    super();
  }

  ngOnInit() {
    /**
     * Listen to fieldsFeatures$ changes and filtering products
     */
    console.log(this.fieldsFeatures);
    // if (this.fieldsFeaturesFast.length>0) {
    //   this.fieldsFeatures = [...this.fieldsFeaturesFast];
    // }
    // console.log(this.fieldsFeatures)
    this.configureFields(this.fieldsFeatures);

    this.paramsSubscribe$ = this.route.queryParams.pipe(
      tap(params => this.filterParams(params)),
      tap(_ => this.configureFields(this.fieldsFeatures)),
      tap(_ => this.cdr.detectChanges()),
    ).subscribe();
  }

  filterParams(params) {
    if (params.keyword !== undefined && params.keyword !== null && params.keyword !== '') {
      this.keyword = params.keyword;
    } else {
      this.keyword = '';
    }

    if (params.catalog_id !== undefined && params.catalog_id !== null && params.catalog_id !== '') {
      this.catalogId = params.catalog_id;

    } else {
      this.catalogId = 0;
    }

    this.cdr.detectChanges();
  }

  private configureFields(fields: FormlyFieldConfig[]): void {

    this.fieldsFeatures = fields;
    this.cntActiveFeatures = 0;
    if (this.fieldsFeatures != undefined) {
      this.fieldsFeatures.forEach(item => {

        if (item.defaultValue != undefined && item.defaultValue != false && item.fieldGroup == undefined) {
          if (item.type == 'checkbox-custom') {
            this.cntActiveFeatures++;
          }
          if (item.type == 'select-multi-filter-property' && item.defaultValue.length > 0) {
            this.cntActiveFeatures++;
          }
          if (item.type == 'select-custom') {
            this.cntActiveFeatures++;
          }
        }

        if (item.fieldGroup != undefined) {
          if ((item.fieldGroup[0].defaultValue !== undefined && item.fieldGroup[0].defaultValue.length > 0) ||
            (item.fieldGroup[1].defaultValue !== undefined && item.fieldGroup[1].defaultValue.length > 0)) {
            this.cntActiveFeatures++;
          }
        }
        this.filter.nextCtnActiveFeatures(this.cntActiveFeatures);
      });
    }
  }

  delete(key) {
    console.log(key);
    let dateFromKey = null;
    let dateToKey = null;
    this.fieldsFeatures.forEach(oneFeature => {
      if (oneFeature.key === key) {
        if (oneFeature.type === 'date-range-picker') {
          dateFromKey = key + '_from';
          dateToKey = key + '_to';
        }
      }
    });
    if ((dateFromKey != null) && dateToKey != null) {
      this.router.navigate(['cabinet', 'dam'], {
        queryParams: {
          [dateFromKey]: null,
          [dateToKey]: null
        },
        queryParamsHandling: 'merge'
      });
    } else {
      this.router.navigate(['cabinet', 'dam'], {
        queryParams: {
          [key]: null,
        },
        queryParamsHandling: 'merge'
      });
    }

    this.cdr.detectChanges();

  }

  deleteMulti(key, value) {
    let newValueOfMulti = null;
    for (const [valueKey, valueItem] of Object.entries(this.route.snapshot.queryParamMap['params'])) {
      if (valueKey.toString() === key.toString()) {
        const newValue = valueItem.toString().split(',').filter(i => i !== value.toString());
        if (newValue.length > 0) {
          newValueOfMulti = newValue.join(',');
        }
      }
    }

    this.router.navigate(['cabinet', 'dam'], {
      queryParams: {
        [key]: newValueOfMulti,
      },
      queryParamsHandling: 'merge'
    });
  }

  reset(): void {
    this.router.navigate(
      ['cabinet', 'dam']);
  }

  getFeatureName(options, value): string {
    const result = options.filter(item => item.value == value);
    return result.shift().label;
  }

  isFiltered(): boolean {
    let isFiltered = false;
    if (this.fieldsFeatures != undefined) {
      this.fieldsFeatures.forEach(item => {
        if (item.templateOptions.isFiltered) {
          isFiltered = true;
        }
      });
    }
    if (this.fieldsFeaturesFast != undefined) {
      this.fieldsFeaturesFast.forEach(item => {
        if (item.templateOptions.isFiltered) {
          isFiltered = true;
        }
      });
    }
    return isFiltered;
  }
}
